"use client";

import { useCallback, useEffect, useState } from "react";
import {
  type GoogleIntegrationStatus,
} from "@/lib/googleIntegrationStatus";
import { fetchGoogleIntegrationStatus } from "@/lib/googleIntegrationStatusFetch";

export function useGoogleIntegrationStatus() {
  const [status, setStatus] = useState<GoogleIntegrationStatus | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);
      setStatus(await fetchGoogleIntegrationStatus({ force: true }));
    } catch (err) {
      const message = err instanceof Error ? err.message : "unknown error";
      setError(message);
      setStatus({ connected: null, sheetsByWorkspace: {} });
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void refetch();
  }, [refetch]);

  return {
    status,
    isLoading,
    error,
    refetch,
  };
}
